<template>
    <div class="ws-success">
        <div class="ws-success-icon">
            <i class="fal fa-check"></i>
        </div>
        <h3 class="ws-success-title">{{ $t('wizard.success_title') }}</h3>
        <p class="ws-success-desc">{{ $t('wizard.success_desc') }}</p>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    name: 'WizardSuccess'
}
</script>

<style scoped>
.ws-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 72px 24px;
    text-align: center;
}

.ws-success-icon {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: linear-gradient(135deg, #d1fae5, #ecfdf5);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 28px;
    box-shadow: 0 8px 30px rgba(16, 185, 129, 0.15);
    animation: ws-pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.ws-success-icon i {
    font-size: 2.4rem;
    color: #10b981;
}

@keyframes ws-pop {
    0% { transform: scale(0.3); opacity: 0; }
    60% { transform: scale(1.1); }
    100% { transform: scale(1); opacity: 1; }
}

.ws-success-title {
    font-size: 1.35rem;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 10px;
    letter-spacing: -0.01em;
}

.ws-success-desc {
    font-size: 0.92rem;
    color: #64748b;
    margin: 0;
    max-width: 420px;
    line-height: 1.6;
}
</style>
